import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { GridComponent, GridDataResult } from '@progress/kendo-angular-grid';
import { State } from '@progress/kendo-data-query';
import {JackingPermissions} from '../../../../../models/permissions/permission.models';
import {FieldPositioningEditor} from '../../../../../models/field-positioning/field-positioning.models';


@Component({
  selector: 'app-field-positioning-grid',
  templateUrl: './field-positioning-grid.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FieldPositioningGridComponent {
  @ViewChild('fieldPositioningGrid') grid?: GridComponent;

  @Input() sidebarCollapsed = false;
  @Input() isModal = false;

  @Input() loading = false;
  @Input() initialLoad = false;
  @Input() fieldPositioningGridLoading = false;

  @Input() fieldPositioningGridData: GridDataResult;
  @Input() fieldPositioningState: State;
  @Input() fieldPositioningColumns: any[] = [];

  @Input() dayCompleted = false;
  @Input() isImplementerActiveForDay = true;
  @Input() permissions: JackingPermissions;

  // Pass AppConfig.settings in from the container
  @Input() config: { isImplementerEnvironment?: boolean } = {};

  // Let the parent decide what to do (nav/download/service calls)
  @Output() edit = new EventEmitter<FieldPositioningEditor>();
  @Output() download = new EventEmitter<{ row: FieldPositioningEditor; isPortrait: boolean }>();

  editFieldPositioning(row: FieldPositioningEditor) {
    this.edit.emit(row);
  }

  downloadFieldPositioning(row: FieldPositioningEditor, isPortrait: boolean) {
    this.download.emit({ row, isPortrait });
  }
}



// WEBPACK FOOTER //
// ./src/pages/jacking-activities/v2/components/field-positioning-grid/field-positioning-grid.component.ts